// extracted by mini-css-extract-plugin
export var category = "_sub-menu-module--category--1d66c";
export var icon = "_sub-menu-module--icon--03010";
export var itemLink = "_sub-menu-module--itemLink--dba9e";
export var linkList = "_sub-menu-module--linkList--2b6a2";
export var menuGroup = "_sub-menu-module--menuGroup--f8f61";
export var menuPanel = "_sub-menu-module--menuPanel--8e250";
export var productLogo = "_sub-menu-module--productLogo--4a735";
export var subMenu = "_sub-menu-module--subMenu--b6916";
export var subMenuItem = "_sub-menu-module--subMenuItem--56d9a";
export var subMenuWrapper = "_sub-menu-module--subMenuWrapper--5675d";
export var techLogo = "_sub-menu-module--techLogo--01dd6";
export var textBlock = "_sub-menu-module--textBlock--b9fbd";